import { Injectable } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { switchMap, take } from 'rxjs/operators';
import { of } from 'rxjs';

import { MerchantAPIResponse } from '../models/merchantresponse.model';
import { CoreService } from '../../shared/services/core.service';
import { EMerchantActions, GetMerchant, GetMerchantSuccess } from '../actions/merchant.actions';

@Injectable()
export class MerchantEffects {
  
  getMerchant$ = createEffect(() => this._actions$.pipe(
    ofType<GetMerchant>(EMerchantActions.GetMerchant),
    switchMap((action) => this.coreService.getMerchanrData(action.payload)),
    switchMap((Merchant:MerchantAPIResponse) => {
      return of(new GetMerchantSuccess(Merchant));
    })
  ));
  
  constructor(
    private coreService: CoreService,
    private _actions$: Actions) {
    }
}
